// src/components/LoadingSpinner.js
import React from "react";
import { useIsMobile } from "../hooks/useIsMobile";
import "./LoadingSpinner.css";

export default function LoadingSpinner({ 
  message = "Loading...", 
  size = "medium",
  fullScreen = false,
  inline = false 
}) {
  const isMobile = useIsMobile();
  
  const sizeClasses = {
    small: "spinner-small",
    medium: "spinner-medium",
    large: "spinner-large"
  };

  if (fullScreen) {
    return (
      <div className="loading-fullscreen">
        <div className={`spinner ${sizeClasses[size] || sizeClasses.medium}`}>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        {message && <p className="loading-message">{message}</p>}
      </div>
    );
  }

  if (inline) {
    return (
      <div className="loading-inline">
        <div className={`spinner ${sizeClasses[size] || sizeClasses.small}`}>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        {message && <span className="loading-message-inline">{message}</span>}
      </div>
    );
  }

  return (
    <div className="loading-container">
      <div className={`spinner ${sizeClasses[size] || sizeClasses.medium}`}>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
}

